import { Calendar } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconCalendar(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Calendar />
    </IconWrapper>
  );
}
